// extracted by mini-css-extract-plugin
export default {"disappearing-popup__content":"disapperaringPopup_disappearing-popup__content__Nl8p+"};